'use client'

import { FadeIn, FadeInStagger } from '@/components/ui/animation/faideIn'
import { Disclosure } from '@headlessui/react'
import { MinusCircleIcon, PlusCircleIcon } from '@heroicons/react/24/outline'
import Link from 'next/link'
// import { DiVim } from 'react-icons/di'

const faqs = [
  {
    question: 'What is AI Forge?',
    answer:
      'AI Forge is on track to become one of the leading AI incubators, offering an intense 12-week programme to AI, Deep Tech, and Machine Learning startups. The programme includes 40 masterclasses (online and offline), mentorship from industry experts, access to perks and special offers up to $200k. The goal is to raise around £150k Pre-Seed funding with a success rate of over 60%, and to secure the optimal SEED round. AI Forge takes 6% equity in the business in exchange for its support.',
  },
  {
    question: 'What kind of startups are you looking for?',
    answer:
      "AI Forge is interested in startups that have AI, Deep Tech, or Machine Learning DNA, but it is more focused on the founders' skills and expertise. The programme is designed for founders who wear multiple hats and can start a successful business.",
  },
  {
    question: 'What does AI Forge offer?',
    answer:
      'AI Forge offers an intense 12-week hybrid programme that includes 40 masterclasses, mentorship from industry experts, access to perks and special offers. The programme takes 6% equity in the business in exchange for its support.',
  },
  {
    question: 'What do mentors do for my business?',
    answer:
      'AI Forge provides access to over 110 industry expert mentors, including c-level executives from leading tech companies and successful business founders. The founders can select three mentors to work with during the programme and follow up continuously with those who are best placed to help them expand their network and make connections they need going forward.',
  },
  {
    question: 'Do I have to pay for anything?',
    answer:
      'No, the founders do not have to pay for anything. AI Forge provides cash, credits, and access to perks and special offers up to $200k to the founders. In exchange, the programme takes 6% equity in the business.',
  },
]

const FAQ = () => {
  return (
    <div className="bg-inherit">
      <FadeInStagger faster className="mx-auto max-w-7xl px-6 pb-10 lg:pb-24">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 ">
          <div className="lg:w-[448px]">
            <div className="self-stretch h-20 flex-col justify-start items-start gap-3 flex">
              <FadeIn
                className="self-stretch  text-base font-semibold leading-normal"
                style={{ color: '#EAECF0' }}
              >
                Support
              </FadeIn>
              <FadeIn className="self-stretch text-white text-[36px] font-semibold leading-[44px]">
                FAQs
              </FadeIn>
            </div>
            <FadeIn className="text-gray-200 font-normal pt-5">
              <span>{'Can’t find the answer you’re looking for?'}</span>
              <Link href="mailto:dealflow@aiforge.org" className="underline">
                Contact us!
              </Link>
            </FadeIn>
          </div>
          <FadeInStagger className="w-full border-0">
            <dl className="mt-10 space-y-4 divide-white/10 w-full">
              {faqs.map((faq) => (
                <Disclosure as="div" key={faq.question}>
                  {({ open }) => (
                    <FadeIn
                      className={`p-8 ${open && 'bg-faq-gradient'} rounded-2xl`}
                    >
                      <dt>
                        <Disclosure.Button className="flex w-full items-start justify-between text-left text-white">
                          <span className="text-base font-semibold leading-7">
                            {faq.question}
                          </span>
                          <span className="ml-6 flex h-7 items-center">
                            {open ? (
                              <MinusCircleIcon
                                className="h-6 w-6 text-[#98A2B3]"
                                aria-hidden="true"
                              />
                            ) : (
                              <PlusCircleIcon
                                className="h-6 w-6 text-[#98A2B3]"
                                aria-hidden="true"
                              />
                            )}
                          </span>
                        </Disclosure.Button>
                      </dt>
                      <Disclosure.Panel as="dd" className="mt-2 pr-12">
                        <p
                          className="text-base leading-6 "
                          style={{ color: '#EAECF0' }}
                        >
                          {faq.answer}
                        </p>
                      </Disclosure.Panel>
                    </FadeIn>
                  )}
                </Disclosure>
              ))}
            </dl>
          </FadeInStagger>
        </div>
      </FadeInStagger>
    </div>
  )
}
export default FAQ
